import moment from 'moment';

const dateFormFormat = 'MM/DD/YYYY';
const dateRenderFormat = 'DD/MM/YYYY';
const dateRegExp = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const MIN_AGE = 18;
const MAX_AGE = 150;

const getAge = (userDate) => moment().diff(moment(userDate, dateRenderFormat), 'years');
const isInvalidDate = (userDate) => !moment(userDate, dateRenderFormat).isValid();
const isMinorAge = (userDate) => getAge(userDate) < MIN_AGE;
const isExcessiveAge = (userDate) => {
  const age = getAge(userDate);
  return age < 0 || age > MAX_AGE; // due to diff returning negative number
};

const validateBirthDate = (form, context) => (rule, userDate, callback) => {
  if (!dateRegExp.test(userDate)) {
    return callback(context.t('Please complete your date of birth'));
  } else if (isInvalidDate(userDate)) {
    // If the format is valid, then we check that the date makes sense
    return callback(context.t('The date of birth you entered is invalid'));
  } else if (isMinorAge(userDate)) {
    return callback(context.t('You must be at least 18 years old to register'));
  } else if (isExcessiveAge(userDate)) {
    return callback(context.t('The year you entered is invalid'));
  }
  // Warning: do not invoke the callback with null / empty string, it doesn't work!
  callback();
};

const toRenderedDate = (formDate) => {
  return formDate ? moment(formDate, dateFormFormat).format(dateRenderFormat) : '';
}

const toSubmitDate = (dateStr) => {
  return dateStr ? moment(dateStr, dateRenderFormat).format(dateFormFormat) : '';
}

export {
  toRenderedDate,
  toSubmitDate,
  validateBirthDate,
};
